import { render, staticRenderFns } from "./User.vue?vue&type=template&id=b35039de&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
import style0 from "./User.vue?vue&type=style&index=0&id=b35039de&prod&lang=scss"
import style1 from "./User.vue?vue&type=style&index=1&id=b35039de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35039de",
  null
  
)

export default component.exports